var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.allow)?_c('v-btn',{staticClass:"language-toggle-button",class:{ 'custom-small': _vm.$vuetify.breakpoint.width < 600 },attrs:{"fab":"","dark":""},on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.ui.language=='en-ca' ? 'fr' : 'en')+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }